module.exports = __webpack_public_path__ + "static/media/NetIcon.6b052f8c.svg";